import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface ReceiptTemplateListPayload {
  includeDeleted?: boolean;
  page?: number;
  limit?: number;
  productId?: number;
}

export interface ReceiptTemplateFormPayload {
  template_code: string;
  template_name: string;
  header?: string;
  footer?: string;
  body: string;
  product_id?: number;
  status?: string;
  notes?: string;
}

const list = (payload: ReceiptTemplateListPayload) => {
  const { includeDeleted, page, limit, productId } = payload;
  const params: Record<string, string> = {};
  if (includeDeleted) params.includeDeleted = 'true';
  if (page) params.page = String(page);
  if (limit) params.limit = String(limit);
  if (productId) params.productId = String(productId);
  const query = new URLSearchParams(params).toString();
  return http.get(`${API_ENDPOINTS.masterReceiptTemplates}${query ? `?${query}` : ''}`);
};

const get = (id: number | string) => http.get(`${API_ENDPOINTS.masterReceiptTemplates}/${id}`);

const create = (payload: ReceiptTemplateFormPayload) => http.post(API_ENDPOINTS.masterReceiptTemplates, payload);

const update = (id: number | string, payload: Partial<ReceiptTemplateFormPayload>) =>
  http.patch(`${API_ENDPOINTS.masterReceiptTemplates}/${id}`, payload);

const remove = (id: number | string) => http.delete(`${API_ENDPOINTS.masterReceiptTemplates}/${id}`);

const ReceiptTemplateService = { list, get, create, update, remove };

export default ReceiptTemplateService;
